<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'setoresCrud'"
          crudName="Setores"
          newText="Novo Setor"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableActive="true"
          :enableView="true"
          :enableSenhaPath="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "setoresTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "id",
        "nome",
        "classifica",
        "finaliza",
        "medicacao",
        "espera",
        "envia_ares_triagem",
        "prioridade",
        "agenda_consulta",
        "mostra_classificacao",
        "capacidade_setor",
        "quantidade_maxima_alerta",
        "actions",
      ],
      tableData: [
        "id",
        "nome",
        "classifica",
        "finaliza",
        "medicacao",
        "espera",
        "envia_ares_triagem",
        "prioridade",
        "agenda_consulta",
        "mostra_classificacao",
        "capacidade_setor",
        "quantidade_maxima_alerta",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "nome",
          "classifica",
          "finaliza",
          "medicacao",
          "espera",
          "prioridade",
          "envia_ares_triagem",
          "agenda_consulta",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          classifica: "Classifica Risco",
          finaliza: "Finaliza Senha",
          medicacao: "Medicação",
          espera: "Espera",
          prioridade: "Muda Prioridade",
          envia_ares_triagem: "Envia para Ares Triagem",
          mostra_classificacao: "Exibe Coluna Classificação de Risco",
          capacidade_setor: "Capacidade do Setor",
          quantidade_maxima_alerta: "Qtd Máxima para Alerta",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          classifica: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          finaliza: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          medicacao: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          espera: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          prioridade: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          envia_ares_triagem: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          agenda_consulta: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
          mostra_classificacao: [
            {
              id: 0,
              text: "Não",
            },
            {
              id: 1,
              text: "Sim",
            },
          ],
        },
        templates: {
          classifica(h, row, index) {
            return row.classifica ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          finaliza(h, row, index) {
            return row.finaliza ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          medicacao(h, row, index) {
            return row.medicacao ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          espera(h, row, index) {
            return row.espera ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          prioridade(h, row, index) {
            return row.prioridade ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          envia_ares_triagem(h, row, index) {
            return row.envia_ares_triagem ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          agenda_consulta(h, row, index) {
            return row.agenda_consulta ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
          mostra_classificacao(h, row, index) {
            return row.mostra_classificacao ? (
              <span class="badge badge-primary">Sim</span>
            ) : (
              <span class="badge badge-secondary">Não</span>
            );
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "setores/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
        classifica: "classifica",
        finaliza: "finaliza",
        medicacao: "medicacao",
        espera: "espera",
        prioridade: "prioridade",
        envia_ares_triagem: "envia_ares_triagem",
        agenda_consulta: "Agenda consulta",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>